import React from 'react';
const NextIcon = (props) => {
    const attribute = Object.assign({}, props);
    const stroke = attribute.stroke || '#3C3F47';
    delete attribute.stroke;
    return (React.createElement("svg", Object.assign({ width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, attribute),
        React.createElement("path", { d: "M9 13L14 8L9 3", stroke: stroke, strokeLinejoin: "round" }),
        React.createElement("path", { d: "M14 8H2", stroke: stroke })));
};
export default NextIcon;
